import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgIf, NgSwitch, NgSwitchCase} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {WizardDataService} from "../services/wizard-data.service";
import {StepOneConfigComponent} from "./steps/step-one-config/step-one-config.component";
import {StepTwoFilesComponent} from "./steps/step-two-files/step-two-files.component";
import {StepThreeProcessComponent} from "./steps/step-three-process/step-three-process.component";
import {StepFourReviewComponent} from "./steps/step-four-review/step-four-review.component";

export enum WizardStep {
    Configuration = 1,
    FileUpload = 2,
    Processing = 3,
    Review = 4,
}

@Component({
  selector: 'app-translation-wizard',
  standalone: true,
    imports: [
        NgSwitch,
        NgSwitchCase,
        MatButton,
        NgIf,
        StepOneConfigComponent,
        StepTwoFilesComponent,
        StepThreeProcessComponent,
        StepFourReviewComponent
    ],
  templateUrl: './translation-wizard.component.html',
  styleUrl: './translation-wizard.component.scss'
})
export class TranslationWizardComponent implements OnInit, OnDestroy {
    wizardStepEnum = WizardStep;
    currentStep: WizardStep = WizardStep.Configuration;

    constructor(private _wizardDataService: WizardDataService) {}

    ngOnInit(): void {
        this.startOver();
    }

    ngOnDestroy(): void {
        this._wizardDataService.reset();
    }

    goToStep(step: WizardStep): void {
        this.currentStep = step;
    }

    startOver(): void {
        this._wizardDataService.reset();
        this.currentStep = WizardStep.Configuration;
    }
}
